module.exports = "<div class=\"c-branding c-branding--journey\">\n    <div class=\"c-branding__headings\">\n        <h2 class=\"c-branding__heading\">Welcome to the Hotel Lobby</h2>\n        <p class=\"c-branding__subheading\">Where everything comes together</p>\n\n        <div class=\"c-branding__logo\">\n            <img src=\"https://s3-eu-west-1.amazonaws.com/products-production-lobby/public/branding-media/journey-logo.svg\" alt=\"Journey - Hotel Digital Marketing\" />\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/brandingBanner.html
// module id = 429
// module chunks = 0